import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const CallsTimesMonthlyEvolution = () => {
    const { chartData } = useServicesChartsDataContext();
    

    const tableColumns = [
            {
                key: 'description',
                header: 'Mês',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'min_time',
                header: 'Tempo Mínimo',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'avg_time',
                header: 'Tempo Médio',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'max_time',
                header: 'Tempo Máximo',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            }
    ];

    return (
        <div style={{ width: '100%', display: 'flex' }}>
            <TableComponent
                data={chartData?.callsTimesMonthlyEvolution}
                columns={tableColumns}
                title="Evolução do Tempo de Chamados no exercício"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};